import type { LodgingPrice } from "@b2bportal/lodging-api";
import { useEnhancedEarnAmount } from "../../../hooks/shared";
import { EnhancedEarnRow } from "../../EnhancedEarn";
import styles from "./styles.module.scss";

interface LodgingCardCashBackProps {
  price: LodgingPrice;
}

const LodgingCardCashBack = ({ price }: LodgingCardCashBackProps) => {
  const { isEnhancedEarnEnabled } = useEnhancedEarnAmount();

  if (!price) return undefined;

  return isEnhancedEarnEnabled ? (
    <EnhancedEarnRow
      totalPrice={price?.totalPrice?.fiat?.value}
      hasLearnMore
      hasExtraContent
    />
  ) : null;
};

export default LodgingCardCashBack;
